import { wrapper, createApiClient, Result, ApiError } from "../base";

import AssetDTO = App.Data.CapacityEditor.AssetDTO;
import CapacityRecord = App.Data.CapacityEditor.CapacityRecordDTO;
import CapacityMutationType = App.Data.CapacityEditor.CapacityMutationTypeDO;
import CapacityDownloadParamsDTO = App.Data.CapacityEditor.CapacityDownloadParamsDTO;

const basePath = `capacity-editor`;
const baseClient = createApiClient();

export default class {
	getAssets(): Promise<Result<AssetDTO[], ApiError>> {
		return wrapper(baseClient.get(`${basePath}/`));
	}

	getMutationTypes(): Promise<Result<CapacityMutationType[], any>> {
		return wrapper(baseClient.get(`${basePath}/mutation-types`));
	}

	getCapacity(
		assetId: number,
		params?: { "snapshot-date": Date }
	): Promise<Result<CapacityRecord[], ApiError>> {
		return wrapper(baseClient.get(`${basePath}/${assetId}`, { params }));
	}

	updateCapacity(
		capacity: CapacityRecord,
		assetId: number
	): Promise<Result<void, ApiError>> {
		return wrapper(baseClient.put(`${basePath}/${assetId}`, capacity));
	}

	deleteCapacity(capacityId: number): Promise<Result<void, ApiError>> {
		return wrapper(baseClient.delete(`${basePath}/${capacityId}`));
	}

	downloadCapacity(
		assetId: number | null,
		params: CapacityDownloadParamsDTO
	): Promise<Result<void, ApiError>> {
		return wrapper(
			baseClient.get(`${basePath}/${assetId ?? "null"}/download`, { params })
		);
	}
}
